// The five trust sections on the home page. Copy sticks to verifiable facts:
// partner names and the registered company details (docs/legal/terms.md).

const brand = (name, src, style, href) => ({ name, src, style, href });

export const banks = [
	brand("RBL Bank", "https://companieslogo.com/img/orig/RBLBANK.NS_BIG-e019d83f.png", "rbl"),
	brand("YES BANK", "https://upload.wikimedia.org/wikipedia/commons/a/a8/Yes_Bank_Logo_in_2024.png", "yes"),
	brand("HDFC BANK", "/images/partners/hdfc.svg", "hdfc"),
	brand("AXIS BANK", "https://upload.wikimedia.org/wikipedia/commons/1/1a/Axis_Bank_logo.svg", "axis")
];

export const cardNetworks = [
	brand("Visa", "/images/partners/visa.svg", "visa"),
	brand("Mastercard", "/images/partners/mastercard.svg", "mastercard"),
	brand("RuPay", "/images/partners/rupay.png", "rupay")
];

export const gateways = [
	brand("Razorpay", "/images/partners/razorpay.svg", "razorpay"),
	brand("PayU", "https://upload.wikimedia.org/wikipedia/commons/d/d9/PayU_India_Logo.svg", "payu"),
	brand("CCAvenue", "https://images.seeklogo.com/logo-png/44/1/ccavenue-logo-png_seeklogo-440305.png", "ccavenue"),
	brand("Kotak Bank", "https://images.seeklogo.com/logo-png/38/1/kotak-mahindra-bank-logo-png_seeklogo-386234.png", "kotak"),
	brand("AXIS BANK", "https://upload.wikimedia.org/wikipedia/commons/1/1a/Axis_Bank_logo.svg", "axis"),
	brand("Easebuzz", "https://cdn.techjockey.com/web/assets/images/techjockey/products/11608_Easebuzzlogo.jpg", "easebuzz")
];

export const mca = brand("Ministry of Corporate Affairs, Government of India", "/images/mca-india.webp", "mca");

export const company = {
	name: "Paydeck Technologies Private Limited",
	cin: "U74999WB2018PTC225880",
	office: "ASO-703, Astra Tower, Rajarhat Main Rd, AA II, Newtown, West Bengal 700135"
};
